import Card from '@/components/shared/Card';
import React from 'react';
const baseClass = 'TransactionsPage';
function TransactionsPage() {
  return (
    <div className={baseClass}>
      <Card className={`${baseClass}--transactions mb-24`}>
        <Card.Header className={`${baseClass}--header`}>
          <Card.Title className={`${baseClass}--title`}>
            Transactions
          </Card.Title>
        </Card.Header>
        <Card.Body className={`${baseClass}--body`}>
          There are no transactions yet.
          {/*<Card.Container className={`${baseClass}--container`}>*/}
          {/*  <div className={`${baseClass}--transactions-list`}>*/}
          {/*    There are no transactions yet.*/}
          {/*  </div>*/}
          {/*</Card.Container>*/}
        </Card.Body>
      </Card>
    </div>
  );
}

export default TransactionsPage;
